<p-tabView [scrollable]="true" >
    <ng-container *ngFor="let tab of tabs">
        <p-tabPanel >
          <ng-content select="[addictional_tabs_start]"></ng-content>
            <ng-template pTemplate="header" *ngIf="customHeadersEnabled; else defaultHeader">
                <ng-container *ngIf="tab.headerTemplate; else errorHeader">
                    <ng-container *ngTemplateOutlet="tab.headerTemplate"></ng-container>
                </ng-container>
            </ng-template>
            <ng-template #defaultHeader>
                {{ tab.header }}
            </ng-template>
            <ng-template #errorHeader>
                <span class="text-red-500"> {{'errors.tabHeaderError' | transloco}} </span>
            </ng-template>
            <ng-template pTemplate="content">
                <ng-container *ngTemplateOutlet="tab.contentTemplate || null"></ng-container>

            </ng-template>

        </p-tabPanel>
    </ng-container>
</p-tabView>
